import UpdatePreOnboarding from "../layout/preOnboarding/UpdatePreOnboarding";
import PageLayout from "./PageLayout";

const PreOnboardingUpdatePage = () => {
  return (
    <PageLayout>
      <UpdatePreOnboarding />
    </PageLayout>
  );
};

export default PreOnboardingUpdatePage;
